import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import dayjs from 'dayjs';

export const registerSelector = (state: RootState) => state.register;

export const registerAlertSelector = createSelector(registerSelector, r => r.alert);
export const registerDataSelector = createSelector(registerSelector, r => r.data);
export const registerMetaSelector = createSelector(registerSelector, r => r.meta);
export const accountCreationInfoSelector = createSelector(
  registerSelector,
  r => r.accountCreationInfo
);
export const registerInsuranceSelector = createSelector(
  registerDataSelector,
  registerMetaSelector,
  ({ shSubscriberNumber, pharmacyPlanId, medicaidId }, { insuranceType, insuranceId }) => ({
    shSubscriberNumber,
    pharmacyPlanId,
    medicaidId,
    insuranceType,
    insuranceId
  })
);

export const registerPersonalSelector = createSelector(
  registerDataSelector,
  ({
    firstName,
    lastName,
    dateOfBirth,
    gender,
    ethnicity,
    streetAddress,
    unitNumber,
    city,
    state,
    zip,
    country,
    email,
    phone,
    registrationStatus
  }) => ({
    firstName,
    lastName,
    dateOfBirth,
    gender,
    ethnicity,
    streetAddress,
    unitNumber,
    city,
    state,
    zip,
    country,
    email,
    phone,
    registrationStatus
  })
);

export const registerPersonalAbridgedSelector = createSelector(
  registerDataSelector,
  ({ firstName, lastName, dateOfBirth, email, registrationStatus }) => ({
    firstName,
    lastName,
    dateOfBirth,
    email,
    registrationStatus
  })
);

export const registerContactSelector = createSelector(registerDataSelector, ({ email, phone }) => ({
  email,
  phone
}));

export const registerValidateConsumerHealthIdsSelector = createSelector(
  registerDataSelector,
  ({ firstName, lastName, dateOfBirth, shSubscriberNumber, pharmacyPlanId, medicaidId }) => ({
    firstName,
    lastName,
    dateOfBirth,
    shSubscriberNumber,
    pharmacyPlanId,
    medicaidId
  })
);

export const registerDataAsConsumerSelector = createSelector(
  registerDataSelector,
  ({
    firstName,
    lastName,
    dateOfBirth,
    gender,
    ethnicity,
    streetAddress,
    unitNumber,
    city,
    state,
    zip,
    country,
    email,
    phone,
    ssn,
    shSubscriberNumber,
    pharmacyPlanId,
    medicaidId
  }) => ({
    registrationStatus: 'AccountVerification',
    firstName,
    lastName,
    dateOfBirth: dayjs(dateOfBirth).format('MM/DD/YYYY'),
    gender: gender || null,
    ethnicity: ethnicity || null,
    shSubscriberNumber: shSubscriberNumber || null,
    pharmacyPlanId: pharmacyPlanId || null,
    medicaidId: medicaidId || null,
    ssn: ssn || null,
    addresses: streetAddress
      ? [
          {
            streetAddress,
            streetAddress2: unitNumber,
            city,
            state,
            postalCode: zip,
            country,
            type: 'HOME',
            primary: true
          }
        ]
      : null,
    emails: email
      ? [
          {
            primary: true,
            value: email,
            verified: false,
            type: 'HOME'
          }
        ]
      : null,
    phones: phone
      ? [
          {
            primary: true,
            value: phone,
            verified: false,
            type: 'MOBILE'
          }
        ]
      : null
  })
);

export const registerAccountSelector = createSelector(
  registerDataSelector,
  ({ username, password, termsAcceptance }) => ({
    username,
    password,
    termsAcceptance
  })
);

export const registerCurrentStepSelector = createSelector(registerSelector, r => r.currentStep);

export const registerSubmittingSelector = createSelector(registerSelector, r => r.isSubmitting);

export const registerErrorSelector = createSelector(registerSelector, r => r.error);

export const registerSessionSelector = createSelector(
  registerSelector,
  r => r.mobileRegistrationSession
);

export const validateConsumerIdSelector = createSelector(registerSelector, r => {
  return r.isAccountAlreadyExist;
});
